import api from '../../lib/api';
import { SurveyFieldGroup } from './types';

export const fetchFieldGroups = async (surveyId: string): Promise<SurveyFieldGroup[]> => {
  const { data } = await api.get<{ success: boolean; data: SurveyFieldGroup[] }>(
    `assessments/${surveyId}/groups`
  );
  return data.data;
};

export const createFieldGroup = async (
  surveyId: string,
  payload: { name: string; weight: number; order?: number; threshold?: number | null }
): Promise<SurveyFieldGroup> => {
  const { data } = await api.post<{ success: boolean; data: SurveyFieldGroup }>(
    `assessments/${surveyId}/groups`,
    payload
  );
  return data.data;
};

export const updateFieldGroup = async (
  surveyId: string,
  groupId: string,
  payload: { name?: string; weight?: number; order?: number; threshold?: number | null }
): Promise<SurveyFieldGroup> => {
  const { data } = await api.put<{ success: boolean; data: SurveyFieldGroup }>(
    `assessments/${surveyId}/groups/${groupId}`,
    payload
  );
  return data.data;
};

export const deleteFieldGroup = async (
  surveyId: string,
  groupId: string
): Promise<void> => {
  await api.delete(`assessments/${surveyId}/groups/${groupId}`);
};

export const reorderFieldGroups = async (
  surveyId: string,
  groups: { id: string; order: number }[]
): Promise<void> => {
  await api.post(`assessments/${surveyId}/groups/reorder`, { groups });
};

export const validateFieldGroupWeights = async (
  surveyId: string
): Promise<boolean> => {
  const { data } = await api.get<{ success: boolean; data: { isValid: boolean } }>(
    `assessments/${surveyId}/groups/validate`
  );
  return data.data.isValid;
};
